import { useState } from 'react';

import { useGetWholesaleAdminRequestsQuery } from '@/features/slice/wholesale-admin';

export const useWholesaleAdminOrderRequests = () => {
  const [currentPage, setCurrentPage] = useState(1);

  const { data, error, isLoading } = useGetWholesaleAdminRequestsQuery({});
  return { data, error, isLoading, currentPage, setCurrentPage };
};
